<template>
  <div class="edit-news-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>
          编辑资讯
          <el-tag v-if="stateName" size="mini" style="margin-left: 10px;" :type="stateTagType">{{ stateName }}</el-tag>
        </span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="goBack">
          <i class="el-icon-close"></i>返回
        </el-button>
      </div>

      <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="标题" prop="title">
              <el-input v-model="formData.title" maxlength="128" show-word-limit placeholder="请输入标题" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分类" prop="typeId">
              <el-select v-model="formData.typeId" placeholder="请选择分类" style="width: 100%;">
                <el-option v-for="t in typeList" :key="t.typeId" :label="t.typeName" :value="t.typeId" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="归属社区" prop="areaId">
              <el-select v-model="formData.areaId" placeholder="请选择归属社区" style="width: 100%;"
                @change="onAreaChange">
                <el-option v-for="a in areaList" :key="a.areaId" :label="a.areaName" :value="a.areaId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="来源" prop="source">
              <el-input v-model="formData.source" maxlength="64" placeholder="请输入来源" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="封面图" prop="headerImg">
          <upload-image-url ref="uploadImage" :image-count="1" @notifyUploadCoverImage="handleImageUpload" />
        </el-form-item>

        <el-form-item label="置顶" prop="isTop">
          <el-switch v-model="formData.isTop" active-value="1" inactive-value="0" />
        </el-form-item>

        <el-form-item label="内容" prop="content">
          <rich-text-editor ref="richTextEditor" v-model="formData.content" :height="400" />
        </el-form-item>

        <el-form-item class="text-right">
          <el-button @click="goBack">返回</el-button>
          <el-button type="primary" :loading="saving" @click="submitForm">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import UploadImageUrl from '@/components/upload/UploadImageUrl'
import RichTextEditor from '@/components/editor/RichTextEditor'
import { listAreaNewsTypes, queryAreaNewsDetail, updateAreaNews } from '@/api/community/areaNewsApi'
import { listAreas } from '@/api/community/areaApi'

export default {
  name: 'EditAreaNews',
  components: {
    UploadImageUrl,
    RichTextEditor
  },
  data() {
    return {
      saving: false,
      loading: false,
      typeList: [],
      areaList: [],
      formData: {
        newsId: '',
        title: '',
        typeId: '',
        areaId: '',
        areaName: '',
        source: '',
        headerImg: '',
        isTop: '0',
        content: '',
        state: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        typeId: [
          { required: true, message: '请选择分类', trigger: 'change' }
        ],
        areaId: [
          { required: true, message: '请选择归属社区', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    stateName() {
      const names = {
        '1000': '草稿',
        '2000': '已发布',
        '3000': '已下架'
      }
      return names[String(this.formData.state)] || ''
    },
    stateTagType() {
      const types = {
        '1000': 'info',
        '2000': 'success',
        '3000': 'warning'
      }
      return types[String(this.formData.state)] || 'info'
    }
  },
  created() {
    this.formData.newsId = this.$route.query.newsId || ''
    if (!this.formData.newsId) {
      this.$message.error('参数缺失：newsId')
      this.goBack()
      return
    }
    this.loadTypes()
    this.loadAreas()
    this.loadDetail()
  },
  methods: {
    loadTypes() {
      listAreaNewsTypes({ page: 1, row: 500 }).then(res => {
        const data = res || {}
        this.typeList = data.types || []
      }).catch(() => {})
    },
    loadAreas() {
      listAreas({ page: 1, row: 500 }).then(res => {
        const data = (res && res.data) || {}
        this.areaList = data.areas || []
      }).catch(() => {})
    },
    loadDetail() {
      this.loading = true
      queryAreaNewsDetail(this.formData.newsId).then(row => {
        this.formData = {
          newsId: row.newsId,
          title: row.title,
          typeId: row.typeId,
          areaId: row.areaId,
          areaName: row.areaName || '',
          source: row.source || '',
          headerImg: row.headerImg || '',
          isTop: String(row.isTop) === '1' ? '1' : '0',
          content: row.content || '',
          state: String(row.state || '')
        }
        this.$nextTick(() => {
          if (this.formData.headerImg) {
            this.$refs.uploadImage.setImages([this.formData.headerImg])
          }
          if (this.formData.content) {
            this.$refs.richTextEditor.setContent(this.formData.content)
          }
        })
      }).catch(error => {
        this.$message.error(error.message || '加载资讯详情失败')
      }).finally(() => {
        this.loading = false
      })
    },
    onAreaChange(areaId) {
      const item = this.areaList.find(a => String(a.areaId) === String(areaId))
      this.formData.areaName = item ? item.areaName : ''
    },
    handleImageUpload(photosUrl) {
      if (photosUrl && photosUrl.length > 0) {
        this.formData.headerImg = photosUrl[0]
      } else {
        this.formData.headerImg = ''
      }
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return false
        this.saveData()
      })
    },
    saveData() {
      this.saving = true
      updateAreaNews(this.formData).then(() => {
        if (this.formData.state === '2000') {
          this.$message.success('保存成功，已发布文章修改即时生效')
        } else {
          this.$message.success('保存成功')
        }
        this.goBack()
      }).catch(error => {
        this.$message.error(error.message || '保存失败')
      }).finally(() => {
        this.saving = false
      })
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-news-container {
  padding: 20px;

  .el-card {
    width: 100%;
  }

  .text-right {
    text-align: right;
  }
}
</style>
